import { Button } from "@/domains/shared/components/Button";
import { SUBSCRIPTION_TRANSLATIONS } from "@/domains/subscription/constants";
import { usePlanAdjustmentNotice } from "@/domains/subscription/hooks/usePlanAdjustmentNotice";
import { getTranslation } from "@mivo/i18n";
import { Info } from "lucide-react";

export default function PlanAdjustmentNoticeBanner() {
    const { showBanner, message, dismiss, dismissing } = usePlanAdjustmentNotice();

    if (!showBanner || !message) {
        return null;
    }

    return (
        <div
            className="border-b border-border bg-muted px-4 py-3 text-sm text-foreground"
            role="status"
            data-testid="plan-adjustment-notice-banner"
        >
            <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3">
                <div className="flex min-w-0 items-start gap-2">
                    <Info className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
                    <p>{message}</p>
                </div>
                <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    disabled={dismissing}
                    onClick={() => void dismiss()}
                    data-testid="plan-adjustment-notice-dismiss"
                >
                    {dismissing
                        ? getTranslation(SUBSCRIPTION_TRANSLATIONS.planAdjustmentDismissLoading)
                        : getTranslation(SUBSCRIPTION_TRANSLATIONS.planAdjustmentDismiss)}
                </Button>
            </div>
        </div>
    );
}
